import { useQuery } from 'react-query';
import { getMySubscription, type MySubscriptionResponse } from '../../services/subscriptionService';

export function useGetMySubscription() {
  return useQuery<MySubscriptionResponse>(['mySubscription'], () => getMySubscription(), {
    staleTime: 0,
    cacheTime: 0
  });
}
